import { ISetting } from './isetting';
import { KeyValuePair } from './key-value-pair.model';

export class BaseSetting implements ISetting {
  constructor(private settings: KeyValuePair[]) {}

  // Achtung die Konvertierung in die Typen number und boolean funktionieren nicht richtig, siehe Umsetzung in urp-setting-dao.model.ts
  public getValue<T>(key: string, defaultValue?: any): T {
    if (!this.settings) {
      return defaultValue;
    }
    const setting = this.settings.find((x) => x.key?.toLowerCase() === key?.toLowerCase());
    if (setting === undefined || setting.value === undefined) {
      return defaultValue;
    }

    const retVal = this.getValueAsObjectIfJson(setting.value);

    return retVal as T;
  }

  public getSettings(): KeyValuePair[] {
    return [];
  }

  public getSettingsJson(): any {
    const settings = this.getSettings();

    const retArr = [];

    for (const setting of settings) {
      retArr.push(setting);
    }
    return retArr;
  }

  private getValueAsObjectIfJson<T>(value: string): T {
    if (/\s*(\{.*\}|\[.*\])\s*/.test(value)) {
      try {
        return JSON.parse(value) as T;
      } catch {
        return value as any;
      }
    } else {
      return value as any;
    }
  }
}
